<nav class="nav nav-secondary account-details-nav">
  <a
    class="nav-item"
    [routerLink]="['/account']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.account.screenreader' | translate: { fgbdefault: 'Move to Account page' } }}"
  >
    <div class="icon material-icons" aria-hidden="true">person</div>
    <label>{{ 'account.nav.profile' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/activity']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.activity.screenreader' | translate: { fgbdefault: 'Move to Activity page' } }}"
  >
    <div class="icon material-icons" aria-hidden="true">history</div>
    <label>{{ 'account.nav.activity' | translate }}</label>
  </a>
</nav>
